// extracted by mini-css-extract-plugin
export default {"tooltip":"yB-z","arrow":"zB-z"};